import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

import {
    getClsData,
    refreshClsData,
    moreClsData,
    getFinanceSelectedData,
    getFinanceStructData,
} from '../../../../services/api';

import TabList from './tabList';
import PromptTone from './promptTone';
import AllNewList from './allNewList';
import GlobalNewList from './globalNewList';

class NewsList extends React.PureComponent {
    state = {
        current: 0,
        liveData: [],
        liveLastid: '',
        livePrevid: '',
        globalData: [],
        globalLastid: '',
        sound: true,
        time: 60 * 1000,
        currentGlobalPage: 0,
        globalDataIsEnd: false,
        loading: false,
        insertLiveTextList: [],
    };

    hasRequestSelectedData = false;

    handleTabsChange = index => {
        this.setState({ current: index }, () => {
            if (!this.hasRequestSelectedData) {
                this.getGlobalData();
            }
        });
    };

    getGlobalData = async () => {
        if (!this.state.loading) {
            this.setState(
                {
                    loading: true,
                },
                async () => {
                    const getFinanceData = await getFinanceSelectedData(
                        '240190',
                        this.state.currentGlobalPage * 20,
                        20,
                    );

                    if (getFinanceData && getFinanceData.data) {
                        this.hasRequestSelectedData = true;
                        this.setState({
                            globalData: [...this.state.globalData, ...getFinanceData.data],
                            currentGlobalPage: this.state.currentGlobalPage + 1,
                            loading: false,
                            globalDataIsEnd: getFinanceData.data.length < 20,
                        });
                    }
                },
            );
        }
    };

    soundChange = soundVal => {
        this.setState({ sound: soundVal });
    };

    /**
     * 请求
     */
    componentDidMount() {
        this.getClsData();

        // const { content } = this.props;

        // this.setState({
        //     globalData: content,
        //     globalLastid: `${content[0].id}`,
        // });

        const { time } = this.state;

        this.timer = setInterval(() => {
            this.refresh();

            // const { content } = this.props;
            // const { globalLastid } = this.state;

            // if (content[0].id !== globalLastid) {
            //     const { globalData, sound } = this.state;
            //     const audio = this.refs.audio;

            //     if (sound) {
            //         audio.play();
            //     }

            //     this.setState({
            //         globalData: content[0].concat(globalData),
            //         globalLastid: `${content[0].id}`,
            //     });
            // }
        }, time);
    }

    /**
     * 卸载定时器
     */
    componentWillUnmount() {
        clearInterval(this.timer);
    }

    /**
     * 初始化数据
     */
    getClsData = async () => {
        try {
            const data = await getClsData(Date.parse(new Date()));
            const structData = await getFinanceStructData();
            const len = data.data.length - 1;

            this.setState({
                liveData: data.data,
                liveLastid: `${data.data[0].id}`,
                livePrevid: `${data.data[len].id}`,
                insertLiveTextList: structData,
            });
        } catch (e) {
            console.error(e);
        }
    };

    /**
     * 刷新直播数据
     */
    refresh = async () => {
        try {
            const { liveLastid, sound } = this.state;
            const data = await refreshClsData(liveLastid);
            const structData = await getFinanceStructData();
            const audio = this.refs.audio;

            if (data) {
                const { liveData } = this.state;
                const len = data.data.length - 1;

                if (sound) {
                    audio.play();
                }

                this.setState({
                    liveData: data.data.concat(liveData),
                    liveLastid: `${data.data[0].id}`,
                    livePrevid: `${data.data[len].id}`,
                    insertLiveTextList: structData,
                });
            }
        } catch (e) {
            console.error(e);
        }
    };

    /**
     * 更多数据
     */
    moreData = async () => {
        try {
            const { livePrevid } = this.state;
            const data = await moreClsData(livePrevid);
            const structData = await getFinanceStructData();

            if (data) {
                const len = data.data.length - 1;
                const { liveData } = this.state;

                this.setState({
                    liveData: liveData.concat(data.data),
                    livePrevid: `${data.data[len].id}`,
                    insertLiveTextList: structData,
                });
            }
        } catch (e) {
            console.error(e);
        }
    };

    insertDataHandle = () => {
        let { insertLiveTextList, liveData } = this.state;

        try {
            const liveDataLength = liveData.length;
            const lastLiveDataTime =
                liveData[liveDataLength - 1]?.ctime && parseInt(liveData[liveDataLength - 1]?.ctime);

            insertLiveTextList = insertLiveTextList.map((item, index) => {
                const ctime =
                    (item.time &&
                        new Date(item.time.replace(/-/g, '/'))
                            .getTime()
                            .toString()
                            .substr(0, 10)) ||
                    '';

                return {
                    id: index,
                    brief: item.title ? `【${item.title}】${item._brief}` : item._brief || '',
                    ucmsid: '',
                    ctime,
                    url: item.url,
                };
            });
            insertLiveTextList = insertLiveTextList.filter(item => item.ctime > lastLiveDataTime);
            liveData = liveData.concat(insertLiveTextList).sort((a, b) => {
                return parseInt(b.ctime) - parseInt(a.ctime);
            });
        } catch (e) {
            console.log(e);
        }

        return liveData;
    };

    render() {
        const { current, globalData, globalDataIsEnd, loading } = this.state;
        let { liveData } = this.state;

        liveData = this.insertDataHandle();

        const getBox = () => {
            if (current === 0) {
                return <AllNewList content={liveData} moreData={() => this.moreData()} />;
            } else if (current === 1) {
                return (
                    <GlobalNewList
                        content={globalData}
                        getMore={this.getGlobalData}
                        isEnd={globalDataIsEnd}
                        loading={loading}
                    />
                );
            }
        };

        return (
            <div className={styles.con}>
                <div className={styles.tit}>
                    <TabList handleTabsChange={this.handleTabsChange} current={current} />
                    <PromptTone onChange={this.soundChange} />
                    <audio src="//p1.ifengimg.com/71f9287bab6b3ce4/2019/12/message.mp3" ref="audio" />
                </div>
                {getBox()}
            </div>
        );
    }
}

export default errorBoundary(NewsList);
